// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSideNavigation_root__1F7NB","container":"LayoutSideNavigation_container__mPvWg","layoutWrapperMain":"LayoutSideNavigation_layoutWrapperMain__1DHGb"};